import firebase from "@/firebase";

let _socket;
let _reconnectTimer;

function connect() {
  _socket = new WebSocket(`wss://socket.betslip.tips`);
  _socket.onopen = async () => {
    console.log("[WS] Connected");
    let user = await firebase.getCurrentUser();
    if (user) {
      let token = await user.getIdToken();
      _socket.send(token);
    }
  };
  _socket.onclose = () => {
    console.log("[WS] Disconnected, reconnecting in 5s...");
    _socket = null;
    clearTimeout(_reconnectTimer);
    _reconnectTimer = setTimeout(() => connect(), 5000);
  };
  _socket.onerror = (err) => {
    console.log("[WS] Error", err);
    _socket.close();
  };
}

const BSocket = () => {
  if (!_socket || _socket.readyState > 1) {
    connect();
  }
  return _socket;
};

export default BSocket;
